export const OUTER_DOOR_BACKGROUND = '#efefef';
export const DOOR_VIEW_COLOR = '#aaaaaa';
export const DOOR_BACKGROUND_IMAGE_COLOR = '#00c3bc';
//# sourceMappingURL=Colors.js.map